import { motion } from 'framer-motion';
import { MessageSquare, FileSearch, Shield, Award } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: MessageSquare,
    title: 'Erstgespräch',
    description: 'Kurze Analyse der Situation.'
  },
  {
    number: '02',
    icon: FileSearch,
    title: 'Struktur & Unterlagen',
    description: 'Aufbau oder Optimierung des QM-Systems.'
  },
  {
    number: '03',
    icon: Shield,
    title: 'Auditvorbereitung',
    description: 'Konkrete Maßnahmen zur Auditsicherheit.'
  },
  {
    number: '04',
    icon: Award,
    title: 'Erfolgreiches Audit',
    description: 'Begleitung bis zur Zulassung oder zum Abschluss.'
  }
];

export const Process = () => {
  return (
    <section data-testid="process-section" className="py-24 md:py-32 bg-[#050505] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block" data-testid="process-caption">
            Unser Prozess
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-6" data-testid="process-headline">
            In 4 Schritten zur AZAV-Zulassung oder zum erfolgreichen Audit
          </h2>
        </motion.div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="process-grid">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
              data-testid={`process-step-${index}`}
            >
              {/* Connector line removed - visually disruptive */}

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8 hover:border-primary/30 transition-all h-full">
                {/* Step number */}
                <div className="text-6xl font-heading font-bold text-white/5 absolute top-4 right-4">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors relative z-10">
                  <step.icon className="w-7 h-7 text-primary" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-heading font-semibold text-white mb-3 relative z-10">{step.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed relative z-10">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
